export enum apiUrlPromotion {
    PROMOTION_CODE = '/v1/promotion-code/',
}
